"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFinalForm = require("react-final-form");

var _SelectAdapter = _interopRequireDefault(require("../../Adapters/SelectAdapter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CapacityTypeSelectComponent = function CapacityTypeSelectComponent(props) {
  var capacityTypes = props.capacityTypes;

  var required = function required(value) {
    return value ? undefined : "Required";
  };

  var optionsloading = props.optionsloading;

  if (optionsloading === undefined) {
    optionsloading = false;
  }

  return /*#__PURE__*/_react.default.createElement(_reactFinalForm.Field, {
    fullWidth: true,
    name: "capacityType",
    label: "Capacity",
    validate: required,
    component: _SelectAdapter.default,
    options: capacityTypes,
    loading: optionsloading,
    subscription: {
      touched: true,
      value: true,
      error: true
    }
  });
};

var _default = CapacityTypeSelectComponent;
exports.default = _default;